module.exports = __webpack_public_path__ + "img/paywall-float.3544a326.png";